module.exports = __webpack_public_path__ + "media/images/flags/bv-b789f839eda2bce4b0e344610c23e9f7.svg";